<script>
import { findPwdByWechat } from '@/api/userPassword'

export default {
  name: 'FindByWechatHandler',
  created () {
    const code = this.$route.query.code
    const state = this.$route.query.state
    let sign = null
    if (state !== '') {
      const signSegs = this.$route.query.state.split('|')
      sign = {
        appId: signSegs[0],
        redirectUri: signSegs[1],
        digest: signSegs[2]
      }
    }
    findPwdByWechat({
      sign,
      code,
      state
    })
      .then(data => {
        this.$router.push({
          path: '/pwd/reset',
          query: {
            secure: data.secure,
            timestamp: data.timestamp,
            digest: data.digest,
            payload: this.$route.query.payload
          }
        })
      })
      .catch(e => {
        if (e.code === 'USER_NOT_EXISTS') {
          this.$router.push(`/500?code=${e.code}&error=${e.message}&state=${state}&opera=find-pwd-change-method`)
          return
        }
        this.$router.push(`/500?code=${e.code}&error=${e.message}`)
      })
  }
}
</script>
